//
//
//
//
//
//
//
//
//
import DepartmentView01 from "@/components/statistical/department/DepartmentView01";
import ForDept from "@/components/statistical/ForDept";
import ForHandle from "@/components/statistical/ForHandle";
import ForLink from "@/components/statistical/ForLink";
export default {
  name: "Department",
  components: {
    DepartmentView01: DepartmentView01,
    ForDept: ForDept,
    ForHandle: ForHandle,
    ForLink: ForLink
  },
  props: [],
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};